import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MainSchema from './MainSchema';
import { canonicalizeString } from '../../../lib/utils';

function mapStateToProps(store, { match }) {
  const { url } = match;
  const cleanPath = url.endsWith('/') ? url.substring(0, url.lastIndexOf('/')) : url;
  const canonicalPath = canonicalizeString(cleanPath, true);
  return {
    canonicalUrl: `https://www.gasbuddy.com${canonicalPath}`,
    path: match.url,
  };
}
export default withRouter(connect(mapStateToProps)(MainSchema));
